import { useEffect, useState } from 'react';
import { captureException } from '@sentry/react';
import { getAppCodes } from './decodeJWT';

/**
 * Hook to fetch and manage app codes from JWT
 * Returns the list of app codes the user has access to
 */
export function useAppCodes(): string[] {
	const [appCodes, setAppCodes] = useState<string[]>([]);

	useEffect(() => {
		getAppCodes()
			.then((codes) => {
				setAppCodes(codes);
			})
			.catch((error) => {
				setAppCodes([]);
				captureException(error);
			});
	}, []);

	return appCodes;
}
